import { render, staticRenderFns } from "./VideoPage.vue?vue&type=template&id=9c30a5dc&scoped=true&"
import script from "./VideoPage.vue?vue&type=script&lang=ts&"
export * from "./VideoPage.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPage.vue?vue&type=style&index=0&id=9c30a5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c30a5dc",
  null
  
)

export default component.exports